// components/ProgramSession.jsx
const ProgramSession = ({ session }) => {
  const { date, time, venue, isOnline, registrationLink } = session;

  return (
    <div className="border-t pt-3 md:pt-4 first:border-t-0 first:pt-0">
      <div className="flex items-start gap-2 mb-2">
        <div className="text-blue-600 flex-shrink-0">
          <svg xmlns="http://www.w3.org/2000/svg" className="h-4 w-4 md:h-5 md:w-5" fill="none" viewBox="0 0 24 24" stroke="currentColor">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M8 7V3m8 4V3m-9 8h10M5 21h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v12a2 2 0 002 2z" />
          </svg>
        </div>
        <div className="text-sm md:text-base">
          <span className="font-medium">{date}</span>
          {time && <span className="text-gray-500 ml-2">({time})</span>}
        </div>
      </div>

      <div className="flex items-start gap-2 mb-3">
        <div className="text-blue-600 flex-shrink-0">
          <svg xmlns="http://www.w3.org/2000/svg" className="h-4 w-4 md:h-5 md:w-5" fill="none" viewBox="0 0 24 24" stroke="currentColor">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M17.657 16.657L13.414 20.9a1.998 1.998 0 01-2.827 0l-4.244-4.243a8 8 0 1111.314 0z" />
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M15 11a3 3 0 11-6 0 3 3 0 016 0z" />
          </svg>
        </div>
        <div className="flex items-center flex-wrap gap-2 text-sm md:text-base">
          <span>{venue}</span>
          {isOnline && (
            <span className="bg-green-100 text-green-800 text-xs px-2 py-0.5 rounded-full">
              Online
            </span>
          )}
        </div>
      </div>

      <a
        href={registrationLink}
        target="_blank"
        rel="noopener noreferrer"
        className="block w-full text-center bg-blue-600 hover:bg-blue-700 active:bg-blue-800 text-white font-medium py-2.5 md:py-2 px-4 rounded-lg transition-colors duration-200 text-sm md:text-base"
      >
        Register Now
      </a>
    </div>
  );
};

export default ProgramSession;